import { render, staticRenderFns } from "./PopupSitesReport.vue?vue&type=template&id=2d504ae3&scoped=true"
import script from "./PopupSitesReport.vue?vue&type=script&lang=js"
export * from "./PopupSitesReport.vue?vue&type=script&lang=js"
import style0 from "./PopupSitesReport.vue?vue&type=style&index=0&id=2d504ae3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d504ae3",
  null
  
)

export default component.exports